// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"rW-z","sponsoredTooltipWrapper":"sW-z","sponsoredTooltip":"tW-z","newCard":"uW-z"};